import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoreModule } from '@app/modules/core/core.module';

const routes: Routes = [];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    CoreModule.forRoot()
  ],
  exports: [RouterModule, CoreModule]
})
export class AppRoutingModule { }
